export default __webpack_public_path__ + "static/media/misc007.3dcdcf10.jpeg";